// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604130842/js/" + chunkId + "." + {"44":"306e9a7b","225":"8d64cf2a","481":"49839562","486":"4c037150","770":"ee08e1de"}[chunkId] + ".0.33104769589100846.chunk.js";
};